import * as React from 'react';
import {HelpPopover} from './components/HelpPopover';

export const helpPopoverRef: React.RefObject<HelpPopover | null> = React.createRef();
export const NO_FIND_FORM = 'undefined';
